export const STORE_WELCOME_OFFERS =
  'casino-heroes/welcome-offers/STORE_WELCOME_OFFERS'
export const SELECT_REWARD = 'casino-heroes/welcome-offers/SELECT_REWARD'
export const SELECT_OFFER_TYPE = 'casino-heroes/welcomeOffers/SELECT_OFFER_TYPE'
